import {Options} from "highcharts";
import {registerPlugin} from "surveylabJsAssets/chart/charts";
import AbstractChart from "surveylabJsAssets/chart/plugin/abstract-chart";

class Column extends AbstractChart {
    protected allChartOptions(): Options {

        const options: Options = {
            chart: {
                type: 'column',
                height: 900,
                width: 675,
            },
            xAxis: {
                labels: {
                    rotation: -90,
                    y: -50,
                    useHTML: false,
                    enabled: true,
                    style: {
                        fontSize: '6pt',
                        overflow: 'none',
                        textOverflow: 'none'
                    }
                },
            },
            yAxis: {
                labels: {

                    useHTML: true,
                    style: {
                        // fontSize: '6pt',
                        fontWeight: '500',
                    },

                    formatter: function () {
                        const value = parseFloat(this.value.toString());
                        let label = '';
                        switch (value) {
                            case 0:
                                label = 'sehr ungern';
                                break;
                            case 3:
                                label = 'sehr gern';
                                break;
                        }

                        return '<span class="option-label">' + label + '</span> ' + this.value + '';
                    }
                },
                min: 0,
                max: 3,
                offset: 0,
                tickInterval: 0.5,
                title: {
                    text: null,
                },

            },
            plotOptions: {
                column: {
                    groupPadding: 0.1,
                    pointPadding: 0,
                    borderWidth: 0,
                    dataLabels: {
                        enabled: false,
                    }
                }
            },
        }

        return super.mergeOptions(super.allChartOptions(), options);
    }
}

// noinspection JSUnusedGlobalSymbols
export default function () {
    registerPlugin(Column)
}